<i
  class="fa fa-circle"
  [style.color]="'#'+hexColor"
  [title]="tooltip">
</i>
